<template>
  <div>
    <template v-if="studiesLoader.total === 0">
      <h3>No active studies</h3>
    </template>
    <template v-else-if="studiesLoader.total === studiesLoader.loaded">
      <template v-if="$parent.routeSection === 0">
        <DispensingUnit :formValue="formValue"></DispensingUnit>
      </template>
      <template v-else-if="$parent.routeSection === 1">
        <Ancillary :formValue="formValue"></Ancillary>
      </template>
      <template v-else-if="$parent.routeSection === 2">
        <PackingCampaign :formValue="formValue"></PackingCampaign>
      </template>
      <template v-else-if="$parent.routeSection === 3">
        <SiteDepotStock :formValue="formValue"></SiteDepotStock>
      </template>
    </template>
  </div>
</template>

<script>
import DispensingUnit from "./Aggregation/DispensingUnit.vue"
import Ancillary from "./Aggregation/Ancillary.vue"
import PackingCampaign from "./Aggregation/PackingCampaign.vue"
import SiteDepotStock from "./Aggregation/SiteDepotStock.vue"


export default {
  name: "AggregatorEditor",
  components: {
    DispensingUnit,
    Ancillary,
    PackingCampaign,
    SiteDepotStock
  },
  props: {
    formValue: {
      type: Object,
      required: true
    },
    isPageLoaded: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      sideMenu: [{
        name: "Dispensing Unit",
        sub: ["Mapping"]
      }, {
        name: "Ancillary",
        sub: ["Mapping"]
      }, {
        name: "Packing Campaign",
        sub: ["Mapping"]
      }, {
        name: "Sites and depot stock",
        sub: ["Sites", "Depots"]
      }],
      headlines: [{
        headline: "Dispensing Unit",
        subHeadline: "Combine multiple dispensing units to aggregate across selected studies"
      }, {
        headline: "Ancillary",
        subHeadline: "Combine multiple ancillaries to aggregate across selected studies"
      }, {
        headline: "Packaging campaigns",
        subHeadline: "Combine multiple packaging campaigns to aggregate across selected studies"
      }, {
        headline: "Sites and depot stock",
        subHeadline: "Combine multiple clinical sites and depots to aggregate across selected studies"
      }],
      // Make sure all study data is loaded in the background, before showing anything to user
      studiesLoader: {
        total: 0,
        loaded: 0
      }
    }
  },
  mounted() {
    this.$emit("setSideMenu", this.sideMenu);
    this.$emit("setHeadlines", this.headlines);

    // Load a new blank version every time aggregation is loaded
    /*if(!this.$route.params.versionId)
        this.$store.state.editor.version = this.$store.getters.newProgramVersion(this.$parent.program.programId);*/
  },
  methods: {
    getAggregationData() {
      this.$store.state.editor.version.data.sites = [];
      this.$store.state.editor.version.data.depots = [];
      this.$store.state.editor.version.data.studies = [];
      this.$store.state.editor.version.data.studyOutputPaths = [];

      // Get latest versions from each studies on program (only get latest completed run)
      for (let study of this.$parent.program.studies) {

        if (this.NullOrUndefined(study) || this.NullOrUndefined(study.forecastVersions))
          continue;
        
        if (!Array.isArray(study.forecastVersions))
          continue;

        if (study.isArchived || !study.forecastVersions.find(x => x.processStatus === 2))
          continue;

        let firstVersion = study.forecastVersions.find(x => x.processStatus === 2);
        if (!firstVersion)
          continue;

        // Create a list on aggregation with all active studies.
        // This is list is needed for compare of old versions
        this.$store.state.editor.version.data.studies.push({
          id: study.studyId,
          name: study.title,
          versionName: firstVersion.title,
          forecastVersionId: firstVersion.forecastVersionId
        });

        this.studiesLoader.total++;

        let thisRef = this;

        // Get data for each study. Data may not be loaded in frontend, so get all data from DB to be sure
        this.$store.dispatch("getForecastVersion", firstVersion.forecastVersionId).then((res) => {

          //NB we in a new scope, so remember to use thisRef variable!.
          
          
          let studyItem = thisRef.$store.state.editor.version.data.studies.find(x => x.id === res.data.parentId);

          //we need to know the physical output path for each study to generate for the "new version" data where it does not run everything
          //It is a hack

          thisRef.$store.state.editor.version.data.studyOutputPaths.push(
              {
                forecastVersionId: res.data.forecastVersionId,
                forecastId: res.data.forecastId,
                studyId: studyItem.id
              }
          );
          // Prepare Sites and Depots for dropdown lists
          // If a study is cloned, ID clash could happen, so append StudyId_VersionId_Site/DepotId
          // Get sites and order by study name
          for (let site of res.data.data.sites) {
            thisRef.$store.state.editor.version.data.sites.push({
              id: studyItem.id + "_" + res.data.forecastVersionId + "_" + site.id,
              name: site.name,
              studyId: res.data.forecastVersionId,
              studyName: studyItem.name
            })
          }

          // Get depots and order by study name
          for (let depot of res.data.data.depots) {
            thisRef.$store.state.editor.version.data.depots.push({
              id: studyItem.id + "_" + res.data.forecastVersionId + "_" + depot.id,
              name: depot.name,
              studyId: res.data.forecastVersionId,
              studyName: studyItem.name
            })
          }

          if (thisRef.NullOrUndefined(thisRef.$store.state.editor.version.data.dispensingUnit.mappings)) {
            // Because IDs can change when clone/copy, update all old IDs so user will not have to select all items again
            for (let mapping of thisRef.$store.state.editor.version.data.dispensingUnit.mappings) {
              mapping.selectedRows = thisRef.changeSelectedRows(mapping.selectedRows, studyItem.id, res.data.forecastVersionId);
              if (mapping.activeIngredientDataSources) {
                for (let api of mapping.activeIngredientDataSources) {
                  api.study = thisRef.changeStudyVersionId(api.study, studyItem.id, res.data.forecastVersionId);
                }
              }

              if (mapping.dispensingUnitDataSources) {
                for (let dun of mapping.dispensingUnitDataSources) {
                  dun.study = thisRef.changeStudyVersionId(dun.study, studyItem.id, res.data.forecastVersionId);
                }
              }

              if (mapping.dosageFormDataSources) {
                for (let df of mapping.dosageFormDataSources) {
                  df.study = thisRef.changeStudyVersionId(df.study, studyItem.id, res.data.forecastVersionId);
                }
              }
            }
          }

          if (!thisRef.NullOrUndefined(thisRef.$store.state.editor.version.data.ancillary.mappings)) {
            for (let mapping of thisRef.$store.state.editor.version.data.ancillary.mappings) {
              mapping.selectedRows = thisRef.changeSelectedRows(mapping.selectedRows, studyItem.id, res.data.forecastVersionId);
              for (let anc of mapping.ancillaryEquipmentDataSources) {
                anc.study = thisRef.changeStudyVersionId(anc.study, studyItem.id, res.data.forecastVersionId);
              }
            }
          }

          if (!thisRef.NullOrUndefined(thisRef.$store.state.editor.version.data.packingCampaign.mappings)) {
            for (let mapping of thisRef.$store.state.editor.version.data.packingCampaign.mappings) {
              mapping.selectedRows = thisRef.changeSelectedRows(mapping.selectedRows, studyItem.id, res.data.forecastVersionId);
              if (mapping.dispensingUnitDataSources) {
                for (let dun of mapping.dispensingUnitDataSources) {
                  dun.study = thisRef.changeStudyVersionId(dun.study, studyItem.id, res.data.forecastVersionId);
                }
              }
            }
          }


          for (let mapping of thisRef.$store.state.editor.version.data.siteMappings) {
            for (let site of mapping.sites) {
              site.selectedRows = thisRef.changeSelectedRows(site.selectedRows, studyItem.id, res.data.forecastVersionId);
            }
          }

          // This "if" is only for legacy json in editor (on ferring)
          if (!thisRef.$store.state.editor.version.data.depotMappings)
            thisRef.$store.state.editor.version.data.depotMappings = [];

          for (let mapping of thisRef.$store.state.editor.version.data.depotMappings) {
            for (let site of mapping.sites) {
              site.selectedRows = thisRef.changeSelectedRows(site.selectedRows, studyItem.id, res.data.forecastVersionId);
            }
          }

          // Update counter
          thisRef.studiesLoader.loaded++;
        });
      }
    },
    changeSelectedRows(oldIds, studyId, newVersionId) {
      let newSelectedList = [];

      for (let id of oldIds) {
        if (id.indexOf(studyId) === -1) {
          newSelectedList.push(id);
          continue;
        }

        // Replace old ids, and replace with StudyId and VersionId. All ids starts with StudyId_Version_...
        let newId = studyId + "_" + newVersionId;
        newSelectedList.push(newId + id.substr(newId.length));
      }

      return newSelectedList;
    },
    changeStudyVersionId(item, studyId, newVersionId) {
      if (item.studyId !== studyId)
        return item;

      item.id = newVersionId;
      return item;
    }
  },
  watch: {
    "isPageLoaded": {
      handler: function (data) {
        if (!data)
          return;

        // Get study data and build aggregation structure
        // Study data may not be loaded, so load all data from backend
        this.getAggregationData();
      }
    }
  }
}
</script>
